module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-sam-b7588be9521bf7cfab926de6fbd19abb.png";